import { useTranslation } from 'react-i18next'

import { Text, VStack } from '@enechain/ecloud-designsystem'

import { Modal } from '~/components/common/Modal'
import { SaveCancelFooter } from '~/components/common/Modal/SaveCancelFooter'

type Props = {
  isOpen: boolean
  isSubmitting: boolean
  /** 対象期間・エリア等のサマリー行（spec AC-032: 提出内容サマリー）。呼び出し側が組み立てる。 */
  summaryLines: string[]
  onClose: () => void
  onConfirm: () => void
}

/**
 * 発電販売計画 提出確認ダイアログ（spec AC-032〜034、design `gsOpenSubmit` 相当）。
 *
 * `~/components/common/Modal` を wrap する（AlertDialog 相当の component は
 * ecloud-designsystem に無いため、既存の SubmitConfirmModal
 * (`~/components/bidding/common/SubmitConfirmModal.tsx`) と同じパターンで実装する）。
 */
export const SubmitConfirmDialog = ({
  isOpen,
  isSubmitting,
  summaryLines,
  onClose,
  onConfirm,
}: Props): React.ReactElement => {
  const { t } = useTranslation()

  const footer = (
    <SaveCancelFooter
      isPending={isSubmitting}
      onCancel={onClose}
      onSave={onConfirm}
      saveLabel={t('page:generationSalesPlanDetail.submitConfirm.confirm')}
      saveLoadingText={t(
        'page:generationSalesPlanDetail.submitConfirm.submitting',
      )}
    />
  )

  return (
    <Modal
      footer={footer}
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      title={t('page:generationSalesPlanDetail.submitConfirm.title')}
    >
      <VStack align="stretch" gap={2}>
        <Text>{t('page:generationSalesPlanDetail.submitConfirm.body')}</Text>
        {summaryLines.map((line) => (
          <Text key={line} fontSize="sm">
            {line}
          </Text>
        ))}
      </VStack>
    </Modal>
  )
}
